import React from "react";
import "./PageBanner.scss";

// props:
// - title: string
// - bg: image url (required)
// - crumbs: [{ label: "Home", href: "/" }, { label: "Services" }]
export default function PageBanner({ title = "Page Title", bg, crumbs = [] }) {
  return (
    <section
      className="avena-pagebanner is-center"
      style={{ "--banner-bg": `url(${bg})` }}
      aria-label={title}
    >
      <div className="container">
        <div className="avena-pagebanner__inner text-center">
          <h1 className="avena-pagebanner__title">{title}</h1>

          <nav className="avena-pagebanner__crumbs" aria-label="Breadcrumb">
            <ol className="breadcrumb mb-0 justify-content-center">
              {crumbs.map((c, i) => {
                const isLast = i === crumbs.length - 1;
                return (
                  <li
                    key={i}
                    className={`breadcrumb-item ${isLast ? "active" : ""}`}
                    aria-current={isLast ? "page" : undefined}
                  >
                    {c.href && !isLast ? <a href={c.href}>{c.label}</a> : <span>{c.label}</span>}
                  </li>
                );
              })}
            </ol>
          </nav>
        </div>
      </div>
    </section>
  );
}
